// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-capture-summary-backdrop {
  position: fixed;
  inset: 0;
  z-index: 4700;
  background: rgba(8, 12, 20, 0.72);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 12px;
}

.lt-capture-summary {
  width: min(640px, 100%);
  max-height: min(86vh, 760px);
  overflow: auto;
  background: #101820;
  color: #f8fafc;
  border-radius: 18px;
  padding: 16px 16px 20px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.35);
}

.lt-capture-summary__header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
}

.lt-capture-summary__header h2 {
  margin: 0 0 4px;
  font-size: 1.15rem;
}

.lt-capture-summary__header p {
  margin: 0;
  color: rgba(248, 250, 252, 0.72);
  font-size: 0.88rem;
}

.lt-capture-summary__close {
  border: 0;
  background: transparent;
  color: #f8fafc;
  font: inherit;
  cursor: pointer;
}

.lt-capture-summary__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 14px;
}

.lt-capture-summary__card {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  padding: 12px;
}

.lt-capture-summary__card h3 {
  margin: 0 0 6px;
  font-size: 1rem;
}

.lt-capture-summary__speech {
  margin: 0 0 8px;
  color: rgba(248, 250, 252, 0.86);
  font-size: 0.9rem;
  line-height: 1.4;
}

.lt-capture-summary__notes {
  margin: 0 0 8px;
  padding-left: 18px;
  color: #fbbf24;
  font-size: 0.85rem;
}

.lt-capture-summary__actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lt-capture-summary__actions button,
.lt-capture-summary__close {
  text-align: left;
}

.lt-capture-summary__actions button {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(8, 119, 188, 0.22);
  color: #fff;
  font: inherit;
  padding: 10px 12px;
  cursor: pointer;
}

.lt-capture-summary__actions button:disabled {
  opacity: 0.6;
  cursor: default;
}

.lt-capture-summary__error {
  color: #fecaca;
}

.lt-capture-summary__done {
  color: #86efac;
  margin: 8px 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingCaptureSummary.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".lt-capture-summary-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 4700;\n  background: rgba(8, 12, 20, 0.72);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 12px;\n}\n\n.lt-capture-summary {\n  width: min(640px, 100%);\n  max-height: min(86vh, 760px);\n  overflow: auto;\n  background: #101820;\n  color: #f8fafc;\n  border-radius: 18px;\n  padding: 16px 16px 20px;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.35);\n}\n\n.lt-capture-summary__header {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.lt-capture-summary__header h2 {\n  margin: 0 0 4px;\n  font-size: 1.15rem;\n}\n\n.lt-capture-summary__header p {\n  margin: 0;\n  color: rgba(248, 250, 252, 0.72);\n  font-size: 0.88rem;\n}\n\n.lt-capture-summary__close {\n  border: 0;\n  background: transparent;\n  color: #f8fafc;\n  font: inherit;\n  cursor: pointer;\n}\n\n.lt-capture-summary__list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 14px;\n}\n\n.lt-capture-summary__card {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 14px;\n  padding: 12px;\n}\n\n.lt-capture-summary__card h3 {\n  margin: 0 0 6px;\n  font-size: 1rem;\n}\n\n.lt-capture-summary__speech {\n  margin: 0 0 8px;\n  color: rgba(248, 250, 252, 0.86);\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.lt-capture-summary__notes {\n  margin: 0 0 8px;\n  padding-left: 18px;\n  color: #fbbf24;\n  font-size: 0.85rem;\n}\n\n.lt-capture-summary__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lt-capture-summary__actions button,\n.lt-capture-summary__close {\n  text-align: left;\n}\n\n.lt-capture-summary__actions button {\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(8, 119, 188, 0.22);\n  color: #fff;\n  font: inherit;\n  padding: 10px 12px;\n  cursor: pointer;\n}\n\n.lt-capture-summary__actions button:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.lt-capture-summary__error {\n  color: #fecaca;\n}\n\n.lt-capture-summary__done {\n  color: #86efac;\n  margin: 8px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
